import React, { useState, useRef } from "react";

export default function ToolTipComponent({ children, text, restrictions }) {
  const [showToolTip, setShowToolTip] = useState(false);
  const refSetTimeout = useRef();
  const onMouseEnterHandler = () => {
    refSetTimeout.current = setTimeout(() => {
      setShowToolTip(true);
    }, 750);
  };

  const onClickHandler = (e) => {
    e.stopPropagation();
    if (showToolTip) {
      onMouseLeaveHandler();
    } else {
      onMouseEnterHandler();
    }
  };
  const onMouseLeaveHandler = () => {
    clearTimeout(refSetTimeout.current);
    setShowToolTip(false);
  };

  return (
    <div
      className="_tooltip-container"
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      onClick={(e) => {
        onClickHandler(e);
      }}
    >
      {children}
      {showToolTip && (
        <div className="_tooltip border border-radius-s shadow">
          {restrictions
            ? text
                .replace("{{ min }}", restrictions.min)
                .replace("{{ max }}", restrictions.max)
            : text}
        </div>
      )}
    </div>
  );
}
